import { useQuery } from "@apollo/client"
import { graphql } from "@/gql"
import { JobTitleColorisedWithNameAndImage } from "../../../app/jobs/components/JobTitleColorisedWithNameAndImage"
import { JobPostingMessagingCardDocument } from "@/gql/graphql"
import { Text } from "@/elements"
import clsx from "clsx"
import Link from "next/link"

graphql(`
  query JobPostingMessagingCard($jobId: ID!) {
    jobPosting(id: $jobId) {
      description
      payString
      ...JobTitleColorisedWithNameAndImage
    }
  }
`)

export const JobPostingMessagingCard = ({ jobId }: { jobId: string }) => {
  const { data } = useQuery(JobPostingMessagingCardDocument, {
    variables: {
      jobId,
    },
    context: {
      version: 2,
    },
  })

  const isCreativeJob = data?.jobPosting.__typename === "CreativeJobPosting"

  if (!data) {
    return null
  }

  return (
    <Link href={`/jobs/${jobId}`} className="str-chat__message-bubble flex flex-col gap-y-2 !bg-bg-3 px-3 pb-3 pt-2">
      <JobTitleColorisedWithNameAndImage
        focusWordColor={isCreativeJob ? "text-secondary-default" : "text-primary-3"}
        commonWordColor="text-fg-1"
        jobPost={data?.jobPosting}
      />
      {data?.jobPosting.description ? (
        <Text variant="caption" className="text-fg-2" maxLines={2}>
          {data?.jobPosting.description}
        </Text>
      ) : null}
      <div className="flex w-min flex-col">
        <Text className="w-max">{data?.jobPosting.payString}</Text>
        <div
          className={clsx(
            "mt-[-2px] h-[1px] w-full rounded-full",
            isCreativeJob ? "bg-secondary-default" : "bg-primary-3"
          )}
        />
      </div>
    </Link>
  )
}
